function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.472,4260a9.455,9.455,0,0,0-5.995-6.962,6,6,0,1,0-7.516,0,9.455,9.455,0,0,0-6,6.962,1.987,1.987,0,0,0,1.969,2.364H39.5A1.986,1.986,0,0,0,41.472,4260Zm-13.753-11.636a4,4,0,1,1,4,4A4.005,4.005,0,0,1,27.719,4248.359Zm10.429,12H25.291a.991.991,0,0,1-.942-1.337,7.664,7.664,0,0,1,7.37-4.663,7.662,7.662,0,0,1,7.37,4.663A.991.991,0,0,1,38.148,4260.359Z",
  transform: "translate(-21.923 -4242.359)"
});

var SvgMenuProfile = function SvgMenuProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.593,
    height: 20,
    viewBox: "0 0 19.593 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-profile.54d0319c.svg";
export { ForwardRef as ReactComponent };